import { queryOptions } from '@tanstack/react-query';

import { getAnnouncementDetail, getAnnouncementHeartCount, getAnnouncementList } from './api';

import type { AxiosInstance } from 'axios';
import type { GetAnnouncementListRequest } from './types';

export const announcementQueries = {
  all: () => ['announcements'] as const,
  lists: () => [...announcementQueries.all(), 'list'] as const,
  list: (instance: AxiosInstance, params?: GetAnnouncementListRequest) =>
    queryOptions({
      queryKey: [...announcementQueries.lists(), params ?? {}] as const,
      queryFn: ({ signal }) => getAnnouncementList(instance, params, signal),
    }),
  details: () => [...announcementQueries.all(), 'detail'] as const,
  detail: (instance: AxiosInstance, announcementId: string) =>
    queryOptions({
      queryKey: [...announcementQueries.details(), announcementId] as const,
      queryFn: ({ signal }) => getAnnouncementDetail(instance, announcementId, signal),
    }),
  hearts: () => [...announcementQueries.all(), 'hearts'] as const,
  heartCount: (instance: AxiosInstance, announcementId: string) =>
    queryOptions({
      queryKey: [...announcementQueries.hearts(), announcementId] as const,
      queryFn: ({ signal }) => getAnnouncementHeartCount(instance, announcementId, signal),
    }),
};
